import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mhuylnzmsyduivoygxhz.supabase.co'
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1odXlsbnptc3lkdWl2b3lneGh6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ2MjUzNzEsImV4cCI6MjA4MDIwMTM3MX0.g40WOo1APYl5EJfIzg-INhlWydDH-zP9cv2xezjMZ6U'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types
export interface Database {
  public: {
    Tables: {
      users: {
        Row: {
          id: number
          name: string
          email: string
          password_hash: string
          is_admin: boolean
          created_at: string
        }
        Insert: {
          name: string
          email: string
          password_hash: string
          is_admin?: boolean
        }
        Update: {
          name?: string
          email?: string
          password_hash?: string
          is_admin?: boolean
        }
      }
      shifts: {
        Row: {
          id: number
          date: string
          type: 'night' | 'weekend' | 'holiday'
          is_available_for_trade: boolean
          created_at: string
        }
        Insert: {
          date: string
          type: 'night' | 'weekend' | 'holiday'
          is_available_for_trade?: boolean
        }
        Update: {
          date?: string
          type?: 'night' | 'weekend' | 'holiday'
          is_available_for_trade?: boolean
        }
      }
      shift_assignments: {
        Row: {
          id: number
          shift_id: number
          user_id: number
          created_at: string
        }
        Insert: {
          shift_id: number
          user_id: number
        }
        Update: {
          shift_id?: number
          user_id?: number
        }
      }
      requests: {
        Row: {
          id: number
          user_id: number
          shift_id: number
          status: 'pending' | 'approved' | 'rejected'
          created_at: string
          approved_by: number | null
          approved_at: string | null
        }
        Insert: {
          user_id: number
          shift_id: number
          status?: 'pending' | 'approved' | 'rejected'
          approved_by?: number | null
          approved_at?: string | null
        }
        Update: {
          status?: 'pending' | 'approved' | 'rejected'
          approved_by?: number | null
          approved_at?: string | null
        }
      }
      trades: {
        Row: {
          id: number
          shift_id: number
          offered_by: number
          taken_by: number | null
          status: 'available' | 'completed'
          created_at: string
        }
        Insert: {
          shift_id: number
          offered_by: number
          taken_by?: number | null
          status?: 'available' | 'completed'
        }
        Update: {
          taken_by?: number | null
          status?: 'available' | 'completed'
        }
      }
      holidays: {
        Row: {
          id: number
          name: string
          date: string
          created_at: string
        }
        Insert: {
          name: string
          date: string
        }
        Update: {
          name?: string
          date?: string
        }
      }
      activity_logs: {
        Row: {
          id: number
          timestamp: string
          user_id: number | null
          user_name: string | null
          action: string
          details: string | null
          category:
            | 'login'
            | 'request'
            | 'trade'
            | 'user'
            | 'holiday'
            | 'shift'
            | 'data'
        }
        Insert: {
          user_id?: number | null
          user_name?: string | null
          action: string
          details?: string | null
          category:
            | 'login'
            | 'request'
            | 'trade'
            | 'user'
            | 'holiday'
            | 'shift'
            | 'data'
        }
      }
    }
  }
}
